import React from 'react';

import { Box } from '@chakra-ui/react';
import { checkStaticDataCompensationEnabled } from 'utils/helpers/featureFlags';

import NoDisciplinaryActions from 'assets/assetsV1/illustrations/noDisciplinaryActions.svg';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { TextBodyMedium, TextLabel, TextLabelSmall } from 'uiToolkitV1/Typography';

export const StakeholderErrorState = ({ heading, description }: { heading: string; description: string }) => (
  <EmptyScreen heading={heading} description={description} illustrationSrc={NoDisciplinaryActions} />
);

export const StakeholderEmptyState = ({ heading }: { heading: string }) => (
  <Box height="70vh" display="flex" justifyContent="center" alignItems="center" width="100%">
    <EmptyScreen heading={heading} illustrationSrc={NoDisciplinaryActions} />
  </Box>
);

const EmployeeCell = ({ displayName, profilePhoto, subtitle, designation }) => (
  <Box display="flex" alignItems="center" py={1}>
    <Avatar name={displayName} src={profilePhoto} size={32} mr={3} />
    <Box>
      <TextBodyMedium>{displayName}</TextBodyMedium>
      <TextLabel>{subtitle}</TextLabel>
      {designation && <TextLabelSmall>{designation}</TextLabelSmall>}
    </Box>
  </Box>
);

const GroupCell = ({ displayLevel, displayName, subtitle }) => (
  <Box display="flex" flexDirection="column" padding="8px 12px">
    <TextLabelSmall>{displayLevel}</TextLabelSmall>
    <TextBodyMedium>{displayName}</TextBodyMedium>
    {subtitle && <TextLabel>{subtitle}</TextLabel>}
  </Box>
);

export const HierarchyLevelCell = ({ data }: { data: any }) => {
  const { function: mockFunctionData, FUNCTION } = data ?? {};
  const functionData = checkStaticDataCompensationEnabled() ? mockFunctionData : { displayName: FUNCTION };

  const { displayName, subtitle, isEmployee, isGroup, profilePhoto, designation, level, displayLevel } =
    functionData ?? {};

  if (isEmployee || level === 'EMPLOYEE') {
    return <EmployeeCell {...{ displayName, profilePhoto, subtitle, designation }} />;
  }

  if (isGroup) {
    return <GroupCell {...{ displayLevel, displayName, subtitle }} />;
  }

  return <TextBodyMedium>{displayName}</TextBodyMedium>;
};
